module.exports = __webpack_public_path__ + "static/media/logoFull.2f289fb9.png";